/* Generate unique IDs for all heading elements on a page, making sure that no existing IDs are amended.

The heading "Comparison table" gets an id of "comparison-table".

The resulting IDs are used by marketing to link to specific parts of a page.

Usage:

<script>
	import '@js/generate-heading-ids';
</script>
*/

import asap from './asap.js';
import GithubSlugger from 'github-slugger';

const slugger = new GithubSlugger();

// The pattern for generating IDs:
// - generate a slug using github-slugger
function generateNewId(text) {
	return slugger.slug(text);
}

function processHeadings() {
	const existingIds = [];
	const headingsWithoutIds = [];

	// Get all elements that already have IDs
	[...document.querySelectorAll('[id]')].forEach(el => {
		existingIds.push(el.id);
	});

	// get all headings without IDs
	[...document.querySelectorAll('article :where(h1, h2, h3, h4, h5, h6)')].forEach(heading => {
		if (!heading.id) {
			headingsWithoutIds.push(heading);
		}
	});

	// generate IDs for headings that don't have them, but make sure they don't conflict with any existing IDs
	headingsWithoutIds.forEach(h => {
		const baseId = generateNewId(h.textContent);
		let newId = baseId;
		let count = 1;
		while (existingIds.includes(newId)) {
			newId = `${baseId}-${count}`
			count++;
		}
		h.id = newId;
		// push the new ID to the list of existing IDs so we also check this one isn't a duplicate in future loops
		existingIds.push(h.id);
	})
}

asap('body', processHeadings);
